import { Navigate, useLocation } from "react-router";
import { useSelector } from "react-redux";

import { BASE_PATH_PREFIX } from "../constants/routes";

const PublicRoute = ({ children }) => {
    const { userData } = useSelector(state => state.auth);
    const location = useLocation();
    const isLoggedIn = userData?.userId;
    
    if (!isLoggedIn) return children;

    const redirectPath = location.state?.from?.pathname || BASE_PATH_PREFIX;
    return <Navigate to={redirectPath} replace />;
};

export default PublicRoute